import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERY, useResponsive } from '@bucketplace/design-system';
import {
  Divider,
  Grid,
  GridItem,
} from '@bucketplace/design-system/bds';

import { ExhibitionProductCard } from '../ExhibitionProductCard';
import { ExhibitionList } from '../Exhibitions/types';

export function OneColList({
  disableVerticalPadding,
  storeItemList,
  badgeType,
  useBuyButton,
  logData,
}: ExhibitionList): ReactElement {
  const { breakpoint } = useResponsive({});
  const isMobile = breakpoint === 'mobile';

  return (
    <Container
      disableVerticalPadding={disableVerticalPadding}
      gap={{
        laptop: '20 0',
        mobile: '16 32',
      }}
    >
      { storeItemList.map((storeItem, index) => (
        <StyledGridItem
          key={storeItem.id}
          column={isMobile ? 'full' : 'half'}
          // 구매하기 버튼은 항상 카드 아래쪽에 위치
          // 배너 뱃지는 카드 상단을 덮기 때문에 baseline 설정
          style={{
            alignSelf: !useBuyButton && badgeType === 'banner' ? 'baseline' : undefined,
          }}
        >
          <ExhibitionProductCard
            flex
            product={storeItem}
            badgeType={badgeType}
            textBadgeList={storeItem.textBadgeList}
            useBuyButton={useBuyButton}
            href={storeItem.getStoreItemHref?.(storeItem.id)}
            linkComponent={storeItem.linkComponent}
            logData={{
              ...logData,
              index,
            }}
          />
          <StyledDivider variant="thin" />
        </StyledGridItem>
      )) }
    </Container>
  );
}

const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'disableVerticalPadding',
})<{ disableVerticalPadding?: boolean }>`
  padding: ${(props) => props.disableVerticalPadding ? 0 : '10px'} 16px;
  > div:first-of-type {
    display: flex;
    flex-wrap: wrap;
  }
`;

const StyledGridItem = styled(GridItem)`
  &:nth-of-type(odd) > hr {
    margin-right: -10px;
    ${MEDIA_QUERY.max('tablet', `
      margin-right: 0;
    `)}
  }
  &:nth-of-type(even) > hr {
    margin-left: -10px;
    ${MEDIA_QUERY.max('tablet', `
      margin-left: -32px;
    `)}
    ${MEDIA_QUERY.max('mobile', `
      margin-left: 0;
    `)}
  }
`;

const StyledDivider = styled(Divider)`
  margin-top: 20px;
  ${MEDIA_QUERY.max('mobile', css`
    margin-top: 16px;
  `)}
`;
